import { Component, OnInit } from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {OverlayConfig, OverlayRef} from 'exc-controls';

@Component({
  selector: 'app-modal-info-mail',
  templateUrl: './modal-info-mail.component.html',
  styles: []
})
export class ModalInfoMailComponent extends ExcTranslation implements OnInit {

  maildata = {Subject: '', Body: ''};

  constructor(private overlayRef: OverlayRef, private overlayConfig: OverlayConfig) {
    super();
    this.maildata.Subject = this.getRessource('SubjectContent', this.overlayConfig.data);
  }

  ngOnInit() {
  }
  proceed() {
    this.overlayRef.close({proceed: true, body: this.maildata.Body, subject: this.maildata.Subject});
  }

}
